import React from 'react';

import styled from 'styled-components';

import { useCommunityInfoContext } from 'components/CommunityInfo/CommunityInfoContext';
import { canShowCommunityInfoPricingData } from 'components/CommunityInfo/utils';
import { useAppSelector } from 'store/hook';

import AdditionalLinks from './additionalLinks/AdditionalLinks';
import BasicInfo from './basicInfo/BasicInfo';
import Comments from './comments/Comments';
import BrochureAndDocs from './documents/BrochureAndDocs';
import Photos from './photos/Photos';
import RateTrends from './rateTrends/RateTrends';
import ShopNotes from './shopNotes/ShopNotes';
import { DEVICE_SIZES } from '../../../constants';
import HistoryDataModal from '../common/history/HistoryDataModal';

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  display: flex;
  gap: 40px;

  @media (min-width: ${DEVICE_SIZES.TABLET}px) {
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-between;
    grid-template-columns: repeat(2, 1fr);
    ${Column} {
      width: 50%;
    }
  }

  @media (max-width: ${DEVICE_SIZES.TABLET}px) {
    flex-wrap: wrap;
    flex-direction: column;
    ${Column} {
      width: 100%;
    }
  }
`;

const General = () => {
  const { history, mode } = useCommunityInfoContext();
  const { currentUser } = useAppSelector((state) => state.auth);
  const showPricingData = canShowCommunityInfoPricingData(currentUser, mode);
  return (
    <Container>
      {Boolean(history) && <HistoryDataModal />}
      <Column>
        <BasicInfo />
        <AdditionalLinks />
        {!currentUser?.isSuperuser && <Comments />}
      </Column>
      <Column>
        <Photos />
        {showPricingData && (
          <>
            <BrochureAndDocs />
            <RateTrends />
            <ShopNotes />
          </>
        )}
      </Column>
    </Container>
  );
};

export default General;
